import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { withRouter } from '~/hocs/router';
import { actionDockSetExpandNotes } from '@/modules/application/actions/dock';
import Expand from './Expand';
import ListItem from './ListItem';

function getOffers(cfgOffers) {
    // noinspection JSUnresolvedVariable
    return cfgOffers.filter((cfgOffer) => cfgOffer.show_in_notes_menu);
}

const Notes = (props) => {
    return (
        <>
            <ListItem title="Заметки" to="/notes/">
                <Expand expand={props.expand} setExpand={props.setExpand}/>
            </ListItem>
            <Collapse in={props.expand}>
                <List disablePadding={true}>
                    {getOffers(props.cfgOffers).map((cfgOffer) => (
                        <ListItem key={cfgOffer.id} title={cfgOffer.offer_name} to={`/notes/${cfgOffer.offer_name}/`}/>
                    ))}
                </List>
            </Collapse>
        </>
    );
};

let Component = Notes;
Component = withRouter(Component);

export default connect(
    (state) => ({
        expand: state.dock.expandNotes,
        cfgOffers: state.cfg.offers,
    }),
    (dispatch) => ({
        setExpand: bindActionCreators(actionDockSetExpandNotes, dispatch),
    })
)(Component);
